import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  preProcessing: {
    product: "",
    module: "",
    testCase: null,
    executeCondition: "",
  },
  postProcessing: {
    product: "",
    module: "",
    testCase: null,
    executeCondition: "",
  },
};

const processingSettingsSlice = createSlice({
  name: "processingSettings",
  initialState,
  reducers: {
    setPreProcessingConfig: (state, action) => {
      state.preProcessing = { ...state.preProcessing, ...action.payload };
    },
    setPostProcessingConfig: (state, action) => {
      state.postProcessing = { ...state.postProcessing, ...action.payload };
    },
    resetPreProcessingConfig: (state) => {
      state.preProcessing = initialState.preProcessing;
    },
    resetPostProcessingConfig: (state) => {
      state.postProcessing = initialState.postProcessing;
    },
    updatePreProcessingProduct: (state, action) => {
      state.preProcessing.product = action.payload;
      state.preProcessing.module = "";
      state.preProcessing.testCase = null;
    },
    updatePreProcessingModule: (state, action) => {
      state.preProcessing.module = action.payload;
      state.preProcessing.testCase = null;
    },
    updatePostProcessingProduct: (state, action) => {
      state.postProcessing.product = action.payload;
      state.postProcessing.module = "";
      state.postProcessing.testCase = null;
    },
    updatePostProcessingModule: (state, action) => {
      state.postProcessing.module = action.payload;
      state.postProcessing.testCase = null;
    },
  },
});

export const {
  setPreProcessingConfig,
  setPostProcessingConfig,
  resetPreProcessingConfig,
  resetPostProcessingConfig,
  updatePreProcessingProduct,
  updatePreProcessingModule,
  updatePostProcessingProduct,
  updatePostProcessingModule,
} = processingSettingsSlice.actions;

export default processingSettingsSlice.reducer; 